import { BaseCache, ListCache } from "../lib/SyncCache.ts";
import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import ApiServer from "../ApiServer.ts";
import { MediaFilterFrontImage, IMedia } from "../server/fizapilib.auto.ts";

export const GalleryListCache = new ListCache<MediaFilterFrontImage>(ApiServer.albumfrontbycreator);

export const GalleryCache = new BaseCache(ApiServer.albumall);


// Augmentation of the generated beans with the properties and methods added dynamically below
declare module "../server/fizapilib.auto.ts" {
  interface MediaFilterFrontImage {
    name :string;
    canAdd:boolean;
    account : any
    getMediaFilter(): (media: IMedia)=>boolean;
  }
}

Object.assign(MediaFilterFrontImage.prototype,{
  onDecode(this : MediaFilterFrontImage): void {
    switch(this.type){
      case "ALL":
        this.name = i18n.get("photos.all");
        this.canAdd = true;
        break;
      case "MOOD_STAR":
        this.name = i18n.get("photos.favorites");
        this.canAdd = false;
        break;
      case "AUTHOR":
        this.canAdd = this.authorIsMe();
        this.account = FwDatas.getProfile(this.accountId);
        this.name = this.account.name;
        break;
      default:
        return;
    }
  },
  getMediaFilter(this:MediaFilterFrontImage): (media: IMedia) => boolean {
    switch(this.type){
      case "MOOD_STAR":
        return (media: IMedia)=>Object.entries(media.moodMap).length>0;
      case "AUTHOR":
        return  (media: IMedia)=>media.accountId===this.accountId
      case "ALL":
        return (media: IMedia)=>true;
      default:
        console.log('unsupported type')
        return (media: IMedia)=>true;
    }
  }
});
